export const MAX_NAME_LENGTH = 255;

const FIRST_NAME_NUMBER = 2;

export const normalizeName = (name = "") =>
  name.replace(/\s/g, "").toLowerCase();

export const isNameTaken = (name, otherNames = []) => {
  const normalized = normalizeName(name);
  return (
    normalized !== "" &&
    otherNames.some((other) => normalizeName(other) === normalized)
  );
};

export const uniqueNumberedName = (base, takenNames = []) => {
  let candidate = base;
  for (
    let nameNumber = FIRST_NAME_NUMBER;
    isNameTaken(candidate, takenNames);
    nameNumber++
  ) {
    candidate = `${base} (${nameNumber})`;
  }
  return candidate;
};

export const getNameError = (name, otherNames, message) =>
  isNameTaken(name, otherNames) ? message : null;
